import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './components';
import './index.css';

//for env remove api_key testing build

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  
    <App />
);
